 import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAuthorization } from "../../../services/config";
import { updateLoading } from "../loader";
import API_ROUTES from "../../../constants/apiRoutes";

const {
  V1: {
    ORDER_HISTORY
     } = {},
} = API_ROUTES;

const fetchOrderHistory = createAsyncThunk(
  "orderHistory/get",
  async (params, { dispatch, getState }) => {
    const API = getAuthorization(getState, { isAuthHeader: true, isSessionKey: true });
    try {
      dispatch(updateLoading(true));
      const response = await API.get(ORDER_HISTORY + params);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      return err;
    }
  }
);

export { fetchOrderHistory };
